import { useTranslation } from "react-i18next";
import * as z from "zod";
import { CustomerServiceRelationRole } from "@services/customer/types";

export const useAddPayerSchema = () => {
  const { t } = useTranslation();

  const phoneRegex = new RegExp(/^\+(?:[0-9]●?){6,14}[0-9]$/);

  return z.object({
    firstName: z.string({
      required_error: t("addPayerModal.form.fields.firstName.errors.required"),
    }),
    lastName: z.string({
      required_error: t("addPayerModal.form.fields.lastName.errors.required"),
    }),
    email: z
      .string({
        required_error: t("addPayerModal.form.fields.email.errors.required"),
      })
      .email(t("addPayerModal.form.fields.email.errors.format")),
    phoneNumber: z
      .string({
        required_error: t(
          "addPayerModal.form.fields.phoneNumber.errors.required",
        ),
      })
      .trim()
      .min(1, {
        message: t("addPayerModal.form.fields.phoneNumber.errors.required"),
      })
      .regex(
        phoneRegex,
        t("addPayerModal.form.fields.phoneNumber.errors.format"),
      ),
    jointBillServiceId: z.number({
      required_error: t(
        "addPayerModal.form.fields.jointBillServiceId.errors.required",
      ),
    }),
    customerServiceRelationRole: z.nativeEnum(CustomerServiceRelationRole, {
      required_error: t(
        "addPayerModal.form.fields.customerServiceRelationRole.errors.required",
      ),
    }),
    agreed: z.literal(true, {
      errorMap: () => ({
        message: t(
          "addPayerModal.form.fields.customerServiceRelationRole.errors.required",
        ),
      }),
    }),
  });
};
